import request from '@/utils/request'

export function getBanner(params={}) {
  return request({
    url: '/api/banner',
    method: 'get',
    params
  })
}

//1.2展会新闻-陶瓷与卫浴展新闻
export function getNews1(params={}) {
  return request({
    url: '/api/news/wyz/tj',
    method: 'get',
    params
  })
}

//1.3展会新闻-陶瓷装备与材料展新闻
export function getNews2(params={}) {
  return request({
    url: '/api/news/clz/tj',
    method: 'get',
    params
  })
}

//1.4活动推荐
export function getActivity(params={}) {
  return request({
    url: '/api/product/tj',
    method: 'get',
    params
  })
}

//1.6展会介绍
export function getNewsDetail(params={}) {
  return request({
    url: '/api/product/tj',
    method: 'get',
    params
  })
}

//友情链接
export function getFlinks(params) {
  return request({
    url: '/api/flinks',
    method: 'get',
    params
  })
}

//支持单位
export function getSupport(params) {
  return request({
    url: '/api/flinks?cid=2',
    method: 'get',
    params
  })
}

//主题馆
export function getMuseum(params) {
  return request({
    url: '/api/museum/tj',
    method: 'get',
    params
  })
}